import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from 'src/auth/guard';
import { DashboardLayout } from 'src/layouts/dashboard';
import { SplashScreen } from 'src/components/loading-screen';

const ManagerHome = lazy(() => import('src/pages/manager/page'));
const ManagerBookings = lazy(() => import('src/pages/manager/bookings/page'));
const ManagerFacilities = lazy(() => import('src/pages/manager/facilities/page'));
const ManagerReports = lazy(() => import('src/pages/manager/reports/page'));
const ManagerSessions = lazy(() => import('src/pages/manager/sessions/page'));

export const managerRoutes = [
  {
    path: 'manager',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { index: true, element: <ManagerHome /> },
      { path: 'bookings', element: <ManagerBookings /> },
      { path: 'facilities', element: <ManagerFacilities /> },
      { path: 'reports', element: <ManagerReports /> },
      { path: 'sessions', element: <ManagerSessions /> },
    ],
  },
];
